import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SummitLink } from '@summit/models';
import { Button } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 's-ui-link-dialog',
  templateUrl: './s-ui-link-dialog.component.html',
  styleUrls: ['./s-ui-link-dialog.component.css'],
  standalone: true,
  //providers: [DynamicDialogRef, DynamicDialogConfig],

  imports: [Button],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SUiLinkDialogComponent {
  linkList: SummitLink[][];

  constructor(
    private dialogRef: DynamicDialogRef,
    dialogConfig: DynamicDialogConfig
  ) {
    this.linkList = dialogConfig.data?.data;
    //console.log('linkList', this.linkList);s
  }

  onSelect($event) {
    this.dialogRef.close($event);
  }
}
